import React from "react";
import { toast } from "react-toastify";
import Joi from 'joi-browser';
import Paper from "@material-ui/core/Paper";
import { Form, Button, Spinner } from "react-bootstrap";
import { getConfig, updateConfig } from "../services/configService";
import PageLoading from "./common/pageLoading";
import FormComponent from './common/formComponent';

class Config extends FormComponent {
  state = {
    data: { 
        collectDataUsage: false
     },
    errors: {},
    processing: false,
  };

  schema = {
    _id: Joi.string().required(),
    collectDataUsage: Joi.boolean()
    .required()
    .label("Collect Data Usage"),
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    await this.getConfig();
  }

  async getConfig() {
    try {
        const { data } = await getConfig();
        const config = data[0]
        this.setState({ data: config });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload } = this.state;

    try {
      await updateConfig(payload);
      
      toast.success("Configuration saved successfully");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  render() {
    const {
        data,
        loading,
        processing
    } = this.state;

    return (
      <React.Fragment>
          <Paper elevation={3}>
            <div className="card">
                <div className="card-header main-color-bg">
                    <h5>Configuration</h5>
                </div>
                <div className="card-body">
                    <span className="card-text">
                        {loading && <PageLoading loading={loading} />}
                        {!loading && (
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Check
                            className="mb-3"
                            name="collectDataUsage"
                            type="switch"
                            id="collectDataUsage"
                            label="Collect Customer Data Usage"
                            onChange={this.handleToggle}
                            checked={data["collectDataUsage"]}
                            custom
                            />
                            <Button type="submit" disabled={this.validate() || processing}>
                            {processing && (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            )}
                            Save
                            </Button>
                        </Form>
                        )}
                    </span>
                </div>
            </div>
        </Paper>
      </React.Fragment>
    );
  }
}

export default Config;